import React, { useEffect, useState } from 'react'

//importing components
import Avatar from 'components/Avatar'
import Control from 'components/Control/Control'
import Date from 'components/Date/Date'
import Divider from 'components/Divider/Divider'
import AntdInput from 'components/Form/Input'
import Label from 'components/Label/Label'
import RichEditor from 'components/RichEditor/index'
import AwardsIconWork from 'components/icons/AwardsIconWork'
import Delete from 'components/icons/Delete'
import Dropdown from 'components/icons/Dropdown'
import {
  Container,
  FormItem,
  Heading,
  IconView,
  SubHeading,
} from '../../EducationDetailStyle'
import moment from 'moment'
const WorkExpAwardForm = ({
  form,
  formName,
  onRemove,
  studentFormData,
  setIsUpdateButtonEnabled,
}) => {
  const [show, setShow] = useState(true)

  const [title, setTitle] = useState(form.getFieldValue([[formName], 'title']))

  const [awardDate, setAwardDate] = useState(
    form.getFieldValue([[formName], 'awarded_on'])
      ? moment(form.getFieldValue([[formName], 'awarded_on'])).format(
          'DD MMMM, YYYY'
        )
      : null
  )
  const [file, setFile] = useState(
    form.getFieldValue([[formName], 'certificate'])
  )

  const [description, setDescription] = useState(
    form.getFieldValue([[formName], 'description'])
  )

  const showHandler = () => {
    show ? setShow(false) : setShow(true)
  }

  const onBlurProjectTitle = e => {
    if (e.target.value.trim()) {
      form.setFieldsValue({ [formName]: { title: e.target.value?.trim() } })
      setTitle(e.target.value?.trim())
    } else {
      form.setFieldsValue({ [formName]: { title: '' } })
      setTitle('')
    }
  }
  const validateDateOfBirth = dateString => {
    const date = moment(dateString, 'DD/MM/YYYY', true)
    return date.isValid()
  }

  const onDateChange = (date, dateString) => {
    if (setIsUpdateButtonEnabled) {
      setIsUpdateButtonEnabled(false)
    }
    const isValidDate = validateDateOfBirth(dateString)
    if (!isValidDate) {
      form.setFieldsValue({
        [formName]: { awarded_on: '' },
      })
      form.setFieldsValue({
        [formName]: { error: 'Please select Received Date' },
      })
      setAwardDate('')
    }
    if (isValidDate) {
      form.setFieldsValue({
        [formName]: {
          awarded_on: moment(dateString, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        },
      })
      setAwardDate(moment(dateString, 'DD/MM/YYYY').format('DD MMMM, YYYY'))
    }
  }

  useEffect(() => {
    form.setFieldsValue({ [formName]: { certificate: file } })
  }, [file])

  const handleInputChange = e => {
    if (setIsUpdateButtonEnabled) {
      setIsUpdateButtonEnabled(false)
    }
  }

  const onChangeDescription = data => {
    if (
      (description == undefined &&
        data
          ?.replace(/<[^>]*>/g, '')
          ?.replace(/&nbsp;/g, ' ')
          ?.trim('') > 0) ||
      description?.toString('html') !== data?.toString('html')
    ) {
      form.setFieldsValue({ [formName]: { description: data } })
      setDescription(data)
      if (setIsUpdateButtonEnabled) {
        setIsUpdateButtonEnabled(false)
      }
    }
  }

  useEffect(() => {
    setTitle(form.getFieldValue([[formName], 'title']))
    setAwardDate(
      form.getFieldValue([[formName], 'awarded_on'])
        ? moment(form.getFieldValue([[formName], 'awarded_on'])).format(
            'DD MMMM, YYYY'
          )
        : null
    )
  }, [
    form.getFieldValue([[formName], 'title']),
    form.getFieldValue([[formName], 'awarded_on']),
  ])
  return (
    <Container column flexStart>
      <Control alignCenter top="10px">
        <Control gap="10px" flexStart>
          <Avatar
            src={<AwardsIconWork />}
            size={50}
            boxShadow={true}
            padding="8px 0px 0px 0px"
            shape="square"
          />
          <Control column>
            <Heading>{title}</Heading>
            <SubHeading>{awardDate}</SubHeading>
          </Control>
        </Control>
        <Control gap="10px" flexEnd>
          <IconView onClick={() => onRemove(false, true, formName)}>
            <Delete />
          </IconView>
          <IconView onClick={() => showHandler()}>
            <Dropdown />
          </IconView>
        </Control>
      </Control>
      {show && (
        <>
          <Divider />
          <Control top="20px" flexStart column>
            <Label>Award Name *</Label>
            <AntdInput
              placeholder="Eg. Please Enter Award Name"
              name={[[formName], 'title']}
              maxLength={120}
              rules={[
                {
                  required: true,
                  min: 3,
                  max: 120,
                  message:
                    'Please enter Title name! Minimum 3 characters, Maximum 120 characters.',
                },
              ]}
              onBlur={onBlurProjectTitle}
              onChange={handleInputChange}
            />
          </Control>
          <FormItem
            name={[[formName], 'awarded_on']}
            rules={[
              {
                required: true,
                message: '',
              },
              {
                validator: (_, value) => {
                  if (awardDate === '' || awardDate === null) {
                    return Promise.reject(
                      new Error('Please provide received date!')
                    )
                  }
                  const isValidDateFormat = moment(
                    value,
                    'YYYY-MM-DD',
                    true
                  ).isValid()

                  if (!isValidDateFormat) {
                    return Promise.reject(
                      new Error(
                        'Please provide a valid Date format (DD/MM/YYYY)!'
                      )
                    )
                  }

                  return Promise.resolve()
                },
              },
            ]}
          >
            <Control flexStart top="20px" column>
              <Label> Received Date *</Label>
              <Date
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                value={
                  form.getFieldValue([[formName], 'awarded_on'])
                    ? moment(form.getFieldValue([[formName], 'awarded_on']))
                    : null
                }
                disabledDate={d => !d || d.isAfter(moment())}
                onChange={onDateChange}
              />
            </Control>
          </FormItem>
          <Control top="20px" flexStart column>
            <Label>Description</Label>
            <FormItem
              name={[[formName], 'description']}
              rules={[
                {
                  required: false,
                  message: 'Please enter description!',
                },
                {
                  min: 3,
                  message: 'Description must be at least 3 characters long!',
                },
              ]}
            >
              <RichEditor value={description} onChange={onChangeDescription} />
            </FormItem>
          </Control>
          {/* <Control flexStart column top="20px">
            <FormItem name={[[formName], 'certificate']}>
              <Label>Certificate </Label>
              {file && Object.keys(file)?.length > 0 && file?.size ? (
                <Control column top="10px" center>
                  <FileReaderVisible
                    file={file}
                    setFile={setFile}
                    setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                  />
                </Control>
              ) : (
                <Control column top="10px" center>
                  <Uploadloader
                    setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                    setFile={setFile}
                    isDefault={true}
                    fileName={
                      studentFormData?.admin?.firstName?.toLowerCase() +
                      '_' +
                      '_certificate'
                    }
                  />
                </Control>
              )}
            </FormItem>
          </Control> */}
        </>
      )}
    </Container>
  )
}

export default WorkExpAwardForm
